var map = {
	"./ion-accordion_2.entry.js": [
		27844,
		9312,
		7844
	],
	"./ion-action-sheet.entry.js": [
		55512,
		9312,
		5512
	],
	"./ion-alert.entry.js": [
		58104,
		9312,
		8104
	],
	"./ion-app_8.entry.js": [
		51768,
		9312,
		1768
	],
	"./ion-avatar_3.entry.js": [
		76488,
		6488
	],
	"./ion-back-button.entry.js": [
		46640,
		9312,
		4259
	],
	"./ion-backdrop.entry.js": [
		12387,
		2387
	],
	"./ion-breadcrumb_2.entry.js": [
		64800,
		9312,
		4800
	],
	"./ion-button_2.entry.js": [
		60308,
		308
	],
	"./ion-card_5.entry.js": [
		32796,
		5176
	],
	"./ion-checkbox.entry.js": [
		944,
		9312,
		944
	],
	"./ion-chip.entry.js": [
		77440,
		7440
	],
	"./ion-col_3.entry.js": [
		90128,
		128
	],
	"./ion-datetime-button.entry.js": [
		93888,
		2620,
		3888
	],
	"./ion-datetime_3.entry.js": [
		59608,
		2620,
		9312,
		9608
	],
	"./ion-fab_3.entry.js": [
		24704,
		9312,
		4704
	],
	"./ion-img.entry.js": [
		66792,
		6792
	],
	"./ion-infinite-scroll_2.entry.js": [
		58924,
		9312,
		8924
	],
	"./ion-input.entry.js": [
		2600,
		9312,
		2600
	],
	"./ion-item-option_3.entry.js": [
		30292,
		9312,
		292
	],
	"./ion-item_8.entry.js": [
		1328,
		9312,
		1328
	],
	"./ion-loading.entry.js": [
		69328,
		9312,
		9328
	],
	"./ion-menu_3.entry.js": [
		22344,
		9312,
		2344
	],
	"./ion-modal.entry.js": [
		83012,
		9312,
		3012
	],
	"./ion-nav_2.entry.js": [
		46176,
		6176
	],
	"./ion-picker-column-internal.entry.js": [
		89420,
		9312,
		9420
	],
	"./ion-picker-internal.entry.js": [
		98916,
		8916
	],
	"./ion-popover.entry.js": [
		62500,
		9312,
		2500
	],
	"./ion-progress-bar.entry.js": [
		37464,
		7464
	],
	"./ion-radio_2.entry.js": [
		44624,
		9312,
		4624
	],
	"./ion-range.entry.js": [
		47744,
		9312,
		7744
	],
	"./ion-refresher_2.entry.js": [
		76936,
		9312,
		6936
	],
	"./ion-reorder_2.entry.js": [
		60376,
		9312,
		376
	],
	"./ion-ripple-effect.entry.js": [
		60272,
		272
	],
	"./ion-route_4.entry.js": [
		43216,
		3216
	],
	"./ion-searchbar.entry.js": [
		66764,
		9312,
		6764
	],
	"./ion-segment_2.entry.js": [
		65860,
		9312,
		8240
	],
	"./ion-select_3.entry.js": [
		56168,
		9312,
		6168
	],
	"./ion-spinner.entry.js": [
		77328,
		9312,
		7328
	],
	"./ion-split-pane.entry.js": [
		59716,
		9716
	],
	"./ion-tab-bar_2.entry.js": [
		3220,
		9312,
		3220
	],
	"./ion-tab_2.entry.js": [
		13044,
		3044
	],
	"./ion-text.entry.js": [
		44040,
		4040
	],
	"./ion-textarea.entry.js": [
		97271,
		9312,
		7271
	],
	"./ion-toast.entry.js": [
		20108,
		9312,
		108
	],
	"./ion-toggle.entry.js": [
		94936,
		9312,
		4936
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21480;
module.exports = webpackAsyncContext;